








































import {Component, Prop, Vue} from 'vue-property-decorator';
import numeral from 'numeral';
import {NumberHelper} from '@/utils/number.helper';

import {GoalVsRegistrationType} from '@/modules/business-plan/modules/models/enums/goalVsRegistrationType';
import {IData, IGoalVsRegistrationData} from './types';

@Component({
  name: 'TableTrTtlMonthlyGoalRegistrationComponent'
})
export default class TableTrTtlMonthlyGoalRegistration extends Vue {
  public numeral = numeral;
  public NumberHelper = NumberHelper;
  public GoalVsRegistrationType = GoalVsRegistrationType;
  public months = new Array(12).fill(0).map((_, index) =>  1 + index);

  @Prop({required: true})
  public storeValues: IGoalVsRegistrationData[];

  @Prop({required: true})
  public data: IData;
}
